import { gql } from "apollo-boost"

export const getMonitoringReportsParticipantsBySubmissionQuery = gql`
  query MonitoringReportsParticipantsBySubmission($id: ID!) {
    MonitoringReportsParticipantsBySubmission(id: $id){
      id
      key
      goal
      appliedAt
      completed
      compliance
      reviewedAt
      verificationDocuments{
        id
        name
        url
      }
      participants{
        id
        age
        type
        amount
        gender
        preventionLevel
      }
    }
  }
`